'use strict';

/*!
 * ignore
 */

let driver = null;

module.exports.get = function() {
  return driver;
};

module.exports.set = function(v) {
  driver = v;
};



//////////////////
// WEBPACK FOOTER
// ./~/mongoose/lib/driver.js
// module id = 330
// module chunks = 0